export default "__VITE_ASSET__D9EJte8h__"